// import { monthnameslong } from 'components/main/main.component'
import { trackEvent } from 'components/main/main.component'
import { Overlay } from 'components/Overlay'
import React, { useRef } from 'react'
import styled from 'styled-components'

const isMobile = window.innerWidth < 712

const StyledCard = styled.div<{
  checked_: boolean
  isActive: boolean
  hasSeason: boolean
}>`
  font-family: var(--font-plex);
  /* flex: ${isMobile ? '0 1 calc(50% - 4px)' : '0 1 calc(25% - 6px)'}; */
  
  background-color: ${({ checked_, hasSeason }) =>
    hasSeason
      ? checked_
        ? 'var(--green-bright-3)'
        : 'var(--beige-bright-2)'
      : 'var(--gray-bright-3)'};

  text-align: center;
  line-height: 1.4em;
  position: relative;

  &:hover {
    cursor: ${props => (props.isActive ? 'default' : 'pointer')};
    opacity: ${props => (isMobile ? undefined : props.isActive ? '1' : '0.7')};
    z-index: ${props => (props.isActive ? '90' : '0')};
  }
  img {
    max-width: ${isMobile ? '80px' : '90px'};
    padding-bottom: 0px;
  }
`

const Name = styled.div`
  width: 100%;
  font-size: 18px;
  line-height: 1.3em;
  flex: 0 0 100%;
  font-weight: 400;
  letter-spacing: 0.2px;
`
const Timeframe = styled.div<{ checked_: boolean }>`
  width: 100%;
  font-size: 13px;
  line-height: 1.4em;
  flex: 0 0 100%;

  color: rgba(32, 35, 70, 0.6);
`

const BottomBackground = styled.div<{ checked_: boolean; hasSeason: boolean }>`
  width: 100%;
  min-height: 70px;
  position: relative;
  padding-top: 15px;
  gap: 0;
  line-height: 1em;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  @media only screen and (max-width: 711px) {
    padding-top: 10px;
  }
`
const ContentContainer = styled.div`
  width: 100%;
  position: relative;
  display: inline-block;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  flex-direction: column;
  gap: 0;
  justify-content: flex-end;
  min-height: 140px;
`

const IlluFrame = styled.div<{ hasSeason: boolean }>`
  width: 100%;
  img {
    opacity: ${({ hasSeason }) => (!hasSeason ? 1 : 1)};
    -webkit-filter: ${({ hasSeason }) =>
      !hasSeason ? 'grayscale(70%)' : undefined};
    filter: ${({ hasSeason }) => (!hasSeason ? 'grayscale(70%)' : undefined)};
  }
`

export const Card = ({
  data,
  hasSeason,
  toggleOverlay,
  isActive,
  rowPosition,
  labels,
  lang = 'de'
}: {
  data: FruitElementType
  hasSeason: boolean
  toggleOverlay: (e: number | undefined) => void
  isActive: boolean
  rowPosition: number
  labels: (string | string[])[]
  lang: 'de' | 'fr'
}) => {
  const usageProps = [
    ['roh', labels[0][0]],
    ['braten', labels[0][1]],
    ['duensten', labels[0][2]],
    ['backen', labels[0][3]],
    ['kompott', labels[0][4]],
    ['waehe', labels[0][5]],
    ['kochen', labels[0][6]]
  ]
  const {
    normfrom,
    normto,
    bez,
    checked,
    checkedAndAvailable,
    id,
    activeColor,
    imageid,
    receipeid
  } = data
  const usage = usageProps
    .map(m => (data[m[0]] ? m[1] : undefined))
    .filter(f => f)
    .join(', ')
  const container = useRef(null)
  const startmonth = new Date(
    1000 * 60 * 60 * 24 * 7 * +normfrom
  ).toLocaleDateString(lang + '-CH', {
    month: 'long'
  })

  const endmonth = new Date(
    1000 * 60 * 60 * 24 * 7 * +normto
  ).toLocaleDateString(lang + '-CH', {
    month: 'long'
  })
  const checked_ = activeColor
    ? !isNaN(Date.parse(checked || '')) && checkedAndAvailable
    : false

  const handleClose = (e: number | undefined) => {
    if (isMobile) document.body.classList.remove('noScroll')

    trackEvent({
      event_label: 'card close',
      even_info: bez
    })

    toggleOverlay(undefined)
  }
  return (
    <StyledCard
      ref={container}
      checked_={checked_}
      onClick={() => {
        if (!isActive && isMobile) document.body.classList.add('noScroll')

        if (!isActive) {
          trackEvent({
            event_label: 'card open',
            even_info: bez
          })
          toggleOverlay(id)
        }
      }}
      isActive={isActive}
      hasSeason={hasSeason}
    >
      <ContentContainer className='ContentContainer'>
        <IlluFrame hasSeason={hasSeason}>
          <img
            src={
              'https://interaktiv.tagesanzeiger.ch/2022/obst-und-gemuese-kalender/Illus/' +
              imageid +
              '-k.png'
            }
          />
          {/* <img src={getIllustration(imageid)} /> */}
        </IlluFrame>
      </ContentContainer>
      <BottomBackground checked_={checked_} hasSeason={hasSeason}>
        <Name>{bez}</Name>
        <Timeframe checked_={checked_}>
          {startmonth} – {endmonth}
        </Timeframe>
      </BottomBackground>
      {isActive && (
        <Overlay
          isChecked={checked_}
          data={data}
          labels={labels}
          handleClose={handleClose}
          rowPosition={rowPosition}
          lang={lang}
        ></Overlay>
      )}
    </StyledCard>
  )
}
const StyledFactListElement = styled.div`
  line-height: 0.7em;
  label {
    font-size: 13px;
    color: var(--brandblue-main);
    opacity: 0.6;
  }
  div {
    line-height: 1.4em;
    font-size: 15px;
    font-weight: 400;
  }
`

const FactListElement = ({
  label,
  content
}: {
  label: string
  content: string | JSX.Element
}) => {
  return (
    <StyledFactListElement>
      <label>{label}</label>
      <div>{content}</div>
    </StyledFactListElement>
  )
}
